var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { sm: "12", md: "12" } }, [
            _c("div", { staticClass: "upgrade-title" }, [
              _c(
                "div",
                { staticClass: "u-woops" },
                [
                  _c("div", { staticClass: "ico" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/logo_r.png"),
                        alt: "upgrade",
                      },
                    }),
                  ]),
                  _c("w-spacer"),
                  _c("span", { staticClass: "upgrade-info" }, [
                    _c("span", [_vm._v("Winfakt Professional")]),
                    _c("span", { staticClass: "price" }, [
                      _vm._v("50 "),
                      _c("span", { staticClass: "eur" }, [_vm._v("EUR")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct(
                              "components.account.pricing.short-per-month"
                            )
                          )
                      ),
                    ]),
                    _c("span", { staticClass: "more" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$ct("components.account.pricing.invoiced-yearly")
                        )
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { sm: "12", md: "12" } }, [
            _c(
              "div",
              { staticClass: "upgrade-header" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("components.common-MissingModule.ug-to-tier1-1")
                    )
                  ),
                ]),
                _c("span", {
                  directives: [
                    {
                      name: "safe-html",
                      rawName: "v-safe-html",
                      value: _vm.$ct(
                        "components.common-MissingModule.ug-to-tier1-2"
                      ),
                      expression:
                        "$ct('components.common-MissingModule.ug-to-tier1-2')",
                    },
                  ],
                  staticClass: "info",
                }),
                _c(
                  "w-link",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.sheduleDemo()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("components.common-MissingModule.schedule-demo")
                      ) + " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { sm: "12", md: "6" } },
            [
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[0]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[1]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[2]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[3]"))
                ),
              ]),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "6" } },
            [
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[4]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[5]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[6]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.professional[7]"))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }